import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

/**
 * Estado de "dispensado" que se desfaz a cada navegação.
 *
 * Serve para avisos que o usuário pode fechar, mas que precisam reaparecer
 * sempre que ele troca de tela — inclusive ao voltar para uma tela onde já
 * havia fechado, porque o gatilho é a mudança de `location.key`, única por
 * entrada do histórico, e não o caminho.
 */
export function useDispensaPorTela() {
  const location = useLocation();
  const [dispensado, setDispensado] = useState(false);
  // Navegação disparada pelo próprio aviso: não deve reabri-lo no destino.
  const ignorarProximaNavegacao = useRef(false);

  useEffect(() => {
    if (ignorarProximaNavegacao.current) {
      ignorarProximaNavegacao.current = false;
      return;
    }
    setDispensado(false);
  }, [location.key]);

  return {
    dispensado,
    /** Fecha o aviso na tela atual. */
    dispensar: () => setDispensado(true),
    /** Fecha o aviso e o mantém fechado na próxima tela (navegação feita pelo aviso). */
    dispensarAoNavegar: () => {
      ignorarProximaNavegacao.current = true;
      setDispensado(true);
    },
  };
}
